var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { getFetchArgs, providesList } from "../../utils.js";
import { authoringApi } from "../api.js";
import { URL_SEGMENTS, TAGS } from "../common.js";
const resource = URL_SEGMENTS.EXPERIMENTATION_GROUP;
const settingsResource = URL_SEGMENTS.EXPERIMENTATION_GROUP_SETTINGS;
const audienceFiltersResource = URL_SEGMENTS.AUDIENCE_FILTER;
const experimentationGroupApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    queryExperimentationGroups: builder.query({
      query: (payload) => getFetchArgs({ resource, payload }),
      providesTags: (result) => providesList(result == null ? void 0 : result.value, TAGS.EXPERIMENTATION_GROUP)
    }),
    getSettingsForExperimentationGroup: builder.query({
      queryFn: (payload, api, extraOptions, fetchWithBaseQuery) => __async(void 0, null, function* () {
        var _a;
        const fetchArgs = getFetchArgs({ resource, payload });
        fetchArgs.url = `${fetchArgs.url}/${settingsResource}`;
        let response = yield fetchWithBaseQuery(fetchArgs);
        if (((_a = response.error) == null ? void 0 : _a.status) === 404) {
          return {
            data: null
          };
        } else if (response.error) {
          return response;
        } else {
          return {
            data: response.data
          };
        }
      }),
      providesTags: (result, error, { id }) => [
        { type: TAGS.EXPERIMENTATION_GROUP_SETTINGS, id },
        ...!!result ? [{ type: TAGS.EXPERIMENTATION_GROUP_SETTINGS, id: result == null ? void 0 : result.id }] : []
      ]
    }),
    getExperimentationGroupAudienceFilterById: builder.query({
      query: (payload) => getFetchArgs({ resource, payload, secondaryResource: audienceFiltersResource }),
      providesTags: (result, error, { id }) => [{ type: TAGS.AUDIENCE_FILTER, id }]
    }),
    queryExperimentationGroupAudienceFilters: builder.query({
      query: (payload) => getFetchArgs({
        resource,
        payload,
        additionalQueryParams: { isArchived: payload.query.isArchived },
        secondaryResource: audienceFiltersResource
      }),
      providesTags: (result) => providesList(result, TAGS.AUDIENCE_FILTER)
    }),
    createOrUpdateExperimentationGroupAudienceFilter: builder.mutation({
      query: (payload) => getFetchArgs({ resource, payload, method: "PUT", secondaryResource: audienceFiltersResource }),
      invalidatesTags: (result, error, { entity }, meta) => {
        var _a;
        return providesList([entity], TAGS.AUDIENCE_FILTER, ((_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.status) === 201);
      }
    })
  })
});
const {
  usePrefetch: usePrefetchExperimentationGroups,
  useGetSettingsForExperimentationGroupQuery,
  useLazyGetSettingsForExperimentationGroupQuery,
  useQueryExperimentationGroupsQuery,
  useLazyQueryExperimentationGroupsQuery,
  useGetExperimentationGroupAudienceFilterByIdQuery,
  useLazyGetExperimentationGroupAudienceFilterByIdQuery,
  useQueryExperimentationGroupAudienceFiltersQuery,
  useLazyQueryExperimentationGroupAudienceFiltersQuery,
  useCreateOrUpdateExperimentationGroupAudienceFilterMutation
} = experimentationGroupApi;
export {
  experimentationGroupApi,
  useCreateOrUpdateExperimentationGroupAudienceFilterMutation,
  useGetExperimentationGroupAudienceFilterByIdQuery,
  useGetSettingsForExperimentationGroupQuery,
  useLazyGetExperimentationGroupAudienceFilterByIdQuery,
  useLazyGetSettingsForExperimentationGroupQuery,
  useLazyQueryExperimentationGroupAudienceFiltersQuery,
  useLazyQueryExperimentationGroupsQuery,
  usePrefetchExperimentationGroups,
  useQueryExperimentationGroupAudienceFiltersQuery,
  useQueryExperimentationGroupsQuery
};
//# sourceMappingURL=experimentation-groups.js.map
